import './App.css';
import Tensorflow from './tensorflow/index.js'

function App() {
  return (
    <div className="App">
        <Tensorflow/>
    </div>
  );
}

export default App;
